/**
 * Stable CSS class names for E2E — RuleServiceV2 tabs container.
 */
export const RST = {
    root: 'rule-service-tabs',
    tabsWrap: 'rule-service-tabs__tabs-wrap',
    tabPanel: 'rule-service-tabs__tab-panel',
} as const;

export const rstCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

